import { createFileRoute } from "@tanstack/react-router";
import { CelebrityResultPage } from "@/components/site/CelebrityResultPage";
import { brianUrlacher } from "@/lib/celebrity-results/brian-urlacher";
import { absoluteUrl } from "@/lib/absolute-url";

const TITLE = "Brian Urlacher Hair Transplant Results | RESTORE® Hair";
const DESC = "See Hall of Famer Brian Urlacher's RESTORE® No-Shave FUE™ hair transplant results, before & after photos and his full hair restoration story.";
const POSTER = "/img/r/wp-2024-07-brainurlacherposter1-e1723148455769.webp";

export const Route = createFileRoute("/results/brian-urlacher")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "article" },
      { property: "og:url", content: "https://restorehair.com/results/brian-urlacher/" },
      { property: "og:image", content: absoluteUrl(POSTER) },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: absoluteUrl(POSTER) },
    ],
    links: [
      { rel: "canonical", href: "https://restorehair.com/results/brian-urlacher/" },
    ],
  }),
  component: () => <CelebrityResultPage data={brianUrlacher} />,
});
